import { motion } from "framer-motion";

// Reusable scroll-triggered reveal: subtle Y translation + opacity fade,
// triggered once when 20% of the element enters the viewport.
export const Reveal = ({
  children,
  delay = 0,
  y = 24,
  className = "",
  as = "div",
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
